import { makeGetReceive1101 } from 'lib/selector';
import * as _ from 'lodash';
import React, { memo, useEffect, useRef } from 'react';
import { Card } from 'react-bootstrap';
import { translate } from 'react-i18next';
import {
  BsFillCaretDownFill,
  BsFillCaretRightFill,
  BsFillCaretUpFill,
} from 'react-icons/bs';
import { GoArrowDown, GoArrowUp, GoPrimitiveSquare } from 'react-icons/go';
import { connect } from 'react-redux';
import { _getStatusIndex, _processMapDataIndex, numberFormat } from 'utils';
import ChartIndex from '../../../hightchart';
import TradingViewModal from './tradingViewModal';

// Hook
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

function CardChart(props) {
  const [idata, setIdata] = React.useState(null);
  const [showChart, setShowChart] = React.useState(false);
  const prevReceive1101 = usePrevious(props.receive1101);

  useEffect(() => {
    const { idata } = props;
    setIdata(idata);
  }, []);

  useEffect(() => {
    if (
      props.receive1101 &&
      !_.isEqual(props.receive1101, prevReceive1101) &&
      props.receive1101.mc === props.idata.mc
    ) {
      const _receive1101 = _processMapDataIndex(props.receive1101);
      setIdata({ ..._receive1101, value: _receive1101.value / 1e6 });
    }
  }, [props.receive1101, props.idata]);

  function handleClickCard() {
    setShowChart(true);
  }

  const { typeIndex, closeIndex, t } = props;
  if (!idata) return null;
  // console.log(idata)
  return (
    <>
      <Card
        className={'card-chart type-index-' + typeIndex}
        onClick={handleClickCard}
      >
        <Card.Body>
          {typeIndex === 3 && (
            <Card.Header className="d-flex flex-row align-items-center">
              <span className="mr-auto txt-content fz-12">{idata.name}</span>
              <div>
                <span
                  className={'fz-12 font-weight-bold ' + idata.cl}
                  id={'index_' + idata.mc}
                >
                  {idata.cIndex}
                </span>
                {idata.cl === 'i' ? (
                  <GoArrowUp className={idata.cl} />
                ) : idata.cl === 'd' ? (
                  <GoArrowDown className={idata.cl} />
                ) : (
                  <GoPrimitiveSquare className={idata.cl} />
                )}
                <span className={'fz-12 ' + idata.cl}>
                  ({idata.change} &nbsp;{idata.changePc})
                </span>
              </div>
            </Card.Header>
          )}
          {/* <Card.Header className="d-flex flex-row align-items-center">
          {typeIndex !== 3 && (
            <Fragment>
                <span className="mr-auto txt-content fz-12">{idata.name}</span>
                <div>
                  <span className={'fz-12 font-weight-bold mr-1 ' + idata.cl}>
                    {idata.cIndex}
                  </span>
                  <span
                    className={'fz-12 ' + idata.cl}
                  >{`${idata.change}(${idata.changePc})`}</span>
                </div>
            </Fragment>
          )}
        </Card.Header> */}
          {typeIndex !== 3 && (
            <Card.Body className="d-flex flex-column">
              {typeIndex === 1 && (
                <div
                  style={{
                    height: '105px',
                    borderRadius: '4px',
                    border: 'solid 1px #42465b',
                    overflow: 'hidden',
                  }}
                >
                  <ChartIndex
                    stock={idata.mc}
                    oIndex={idata.oIndex}
                    cl={idata.cl}
                  />
                </div>
              )}
              <div className="d-flex flex-row align-items-center h_20">
                <span className="mr-auto txt-content fz-12">{idata.name}</span>
                <div>
                  <span
                    className={'fz-12 font-weight-bold ' + idata.cl}
                    id={'index_' + idata.mc}
                  >
                    {idata.cIndex}
                  </span>
                  {idata.cl === 'i' ? (
                    <GoArrowUp className={idata.cl} />
                  ) : idata.cl === 'd' ? (
                    <GoArrowDown className={idata.cl} />
                  ) : (
                    <GoPrimitiveSquare className={idata.cl} />
                  )}
                  <span className={'fz-12 ' + idata.cl}>
                    ({idata.change} &nbsp;{idata.changePc})
                  </span>
                </div>
              </div>

              <div className="d-flex flex-row align-items-center h_20">
                <span className="mr-auto">
                  <span className="txt-content fz-12 pr-2">{t('txt-vol')}</span>
                  <span className="txt-content fz-12 font-weight-bold">
                    {numberFormat(idata.vol, 0)}
                  </span>
                </span>
                <span>
                  <span className="txt-content fz-12 pr-2">{`${t(
                    'txt-giatri'
                  )} (${t('txt-label-billion')})`}</span>
                  <span className="txt-content fz-12 font-weight-bold">
                    {numberFormat(idata.value / 1000, 0)}
                  </span>
                </span>
              </div>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <span className="txt-content fz-12">{`[${_getStatusIndex(
                  idata.status,
                  idata.mc
                )}]`}</span>
                <span className="i fz-12">
                  <BsFillCaretUpFill className="up_mark" />
                  {idata.up}
                </span>
                <span className="d fz-12">
                  <BsFillCaretDownFill className="down_mark" />
                  {idata.down}
                </span>
                <span className="r fz-12">
                  <BsFillCaretRightFill className="unchange_mark" />
                  {idata.rel}
                </span>
              </div>
            </Card.Body>
          )}
        </Card.Body>
      </Card>
      {showChart && (
        <TradingViewModal
          symbol={idata.name}
          onClose={() => setShowChart(false)}
        />
      )}
    </>
  );
}

const makeMapStateToProps = () => {
  const getReceive1101 = makeGetReceive1101();
  const mapStateToProps = (state) => {
    return {
      receive1101: getReceive1101(state),
    };
  };
  return mapStateToProps;
};
export default connect(makeMapStateToProps)(
  translate('translations')(memo(CardChart))
);
